import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../../../utils';
import {
  listAccountMasterv2,
  listAccountMasterSearch,
  ListAccountMasterSearchQueryVariables,
  GetPartyMasterAccountWiseQuery,
  GetPartyMasterAccountWiseQueryVariables,
  getAccountGSTDetails,
  GetAccountGSTDetailsQuery,
  GetAccountGSTDetailsQueryVariables,
  GetBankDetailsByAccountNameQueryVariables,
  CustomCreateAccountMasterMutation,
  CreateAccountMasterMutationVariables,
  createAccountMasterCustom,
  createAccountGSTDetails,
  createBankDetails,
  updateAccountMaster,
  updateAccountGSTDetails,
  deleteAccountMaster,
  getPartyMasterAccountWiseCustom,
  CreateAccountGSTDetailsMutationVariables,
  CreateBankDetailsMutation,
  CreateBankDetailsMutationVariables,
  CreateAccountGSTDetailsMutation,
  UpdateAccountMasterMutation,
  UpdateAccountMasterMutationVariables,
  UpdateAccountGSTDetailsMutationVariables,
  UpdateAccountGSTDetailsMutation,
  DeleteAccountMasterMutation,
  DeleteAccountMasterMutationVariables,
  getBankDetailsByAccountNameCustom,
  CustomGetBankDetailsByAccountNameQuery,
  ListAccountMasterv2Query,
  ListAccountMasterv2QueryVariables,
} from '../../../graphql';
import {
  AccountMasterListResponse,
  GetAccountGSTDetailsQueryResponse,
  GetBankDetailsByAccountNameQueryResponseCustom,
  ListAccountMasterSearchQueryResponse,
} from '../../../types/graphql';

export const listAccountMasterv3Api = createApi({
  reducerPath: 'listAccountMasterv3',
  baseQuery: baseQuery,
  tagTypes: [
    'dashboard',
    'listAccountMaster',
    'listAccountMasterSearch',
    'partyDetailsByAccountId',
    'accountGSTDetails',
    'bankDetailsByAccountName',
    'allaccounts',
  ],
  endpoints: (builder) => ({
    listAccountMasterv2: builder.query<AccountMasterListResponse, ListAccountMasterv2QueryVariables>({
      query: () => ({ body: listAccountMasterv2 }),
      keepUnusedDataFor: 300,
      transformResponse: (response: ListAccountMasterv2Query) => response?.listAccountMasterv2 || [],
      providesTags: ['listAccountMaster'],
    }),

    listAccountMasterSearch: builder.query<ListAccountMasterSearchQueryResponse, ListAccountMasterSearchQueryVariables>({
      query: (variables) => ({ body: listAccountMasterSearch, variables }),
      keepUnusedDataFor: 180,
      providesTags: (result, error, { word }) => [{ id: word, type: 'listAccountMasterSearch' }],
    }),

    partyDetailsBYAccountId: builder.query<GetPartyMasterAccountWiseQuery, GetPartyMasterAccountWiseQueryVariables>({
      query: (variables) => ({ body: getPartyMasterAccountWiseCustom, variables }),
      keepUnusedDataFor: 180,
      providesTags: (result, error, { accountsid }) => [{ id: accountsid, type: 'partyDetailsByAccountId' }],
    }),

    getAccountGSTDetailsData: builder.query<GetAccountGSTDetailsQueryResponse, GetAccountGSTDetailsQueryVariables>({
      query: (variables) => ({ body: getAccountGSTDetails, variables }),
      keepUnusedDataFor: 180,
      transformResponse: (response: GetAccountGSTDetailsQuery) => response?.getAccountGSTDetails || [],
      providesTags: ['accountGSTDetails'],
    }),

    getBankDetailsByAccountName: builder.query<GetBankDetailsByAccountNameQueryResponseCustom, GetBankDetailsByAccountNameQueryVariables>({
      query: (variables) => ({ body: getBankDetailsByAccountNameCustom, variables }),
      keepUnusedDataFor: 180,
      transformResponse: (response: CustomGetBankDetailsByAccountNameQuery) => response?.getBankDetailsByAccountName || [],
      providesTags: (result, error, { accountname }) => [{ id: accountname, type: 'bankDetailsByAccountName' }],
    }),

    createAccountMaster: builder.mutation<CustomCreateAccountMasterMutation, CreateAccountMasterMutationVariables>({
      query: (variables) => ({ body: createAccountMasterCustom, variables }),
      invalidatesTags: ['dashboard', 'listAccountMaster', 'allaccounts', 'partyDetailsByAccountId'],
    }),
    createAccountGSTDetails: builder.mutation<CreateAccountGSTDetailsMutation, CreateAccountGSTDetailsMutationVariables>({
      query: (variables) => ({ body: createAccountGSTDetails, variables }),
      invalidatesTags: ['accountGSTDetails'],
    }),
    createBankDetails: builder.mutation<CreateBankDetailsMutation, CreateBankDetailsMutationVariables>({
      query: (variables) => ({ body: createBankDetails, variables }),
      invalidatesTags: ['listAccountMaster', 'bankDetailsByAccountName'],
    }),
    updateAccountMaster: builder.mutation<UpdateAccountMasterMutation, UpdateAccountMasterMutationVariables>({
      query: (variables) => ({ body: updateAccountMaster, variables }),
      invalidatesTags: ['listAccountMaster', 'allaccounts', 'partyDetailsByAccountId'],
    }),
    updateAccountGSTDetails: builder.mutation<UpdateAccountGSTDetailsMutation, UpdateAccountGSTDetailsMutationVariables>({
      query: (variables) => ({ body: updateAccountGSTDetails, variables }),
      invalidatesTags: ['accountGSTDetails'],
    }),
    deleteAccountMaster: builder.mutation<DeleteAccountMasterMutation, DeleteAccountMasterMutationVariables>({
      query: (variables) => ({ body: deleteAccountMaster, variables }),
      invalidatesTags: ['dashboard', 'listAccountMaster', 'allaccounts', 'partyDetailsByAccountId'],
    }),
  }),
});

export const {
  usePartyDetailsBYAccountIdQuery,
  useUpdateAccountGSTDetailsMutation,
  useGetBankDetailsByAccountNameQuery,
  useListAccountMasterv2Query,
  useLazyListAccountMasterv2Query,
  useCreateAccountMasterMutation,
  useCreateAccountGSTDetailsMutation,
  useCreateBankDetailsMutation,
  useUpdateAccountMasterMutation,
  useGetAccountGSTDetailsDataQuery,
  useDeleteAccountMasterMutation,
  useListAccountMasterSearchQuery,
} = listAccountMasterv3Api;
